import React from 'react';
import { PhoneCall, Target, Users, HandCoins, Send } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { fmtMoney } from '@/components/crm/crmHelpers';

export const pct = (v) => (v == null ? '—' : `${Math.round(v * 100)}%`);

const Kpi = ({ icon: Icon, label, value, sub, tone = 'text-slate-900', testId }) => (
  <Card className="p-4 border-slate-200 bg-white" data-testid={testId}>
    <div className="flex items-center justify-between gap-2">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</p>
      <Icon className="w-4 h-4 text-slate-400" />
    </div>
    <p className={`text-2xl font-bold mt-1 ${tone}`}>{value}</p>
    {sub && <p className="text-[11px] text-slate-500 mt-0.5">{sub}</p>}
  </Card>
);

export const GestionKpis = ({ totals, promises }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
    <Kpi icon={PhoneCall} label="Gestiones" value={totals.total} testId="gestion-kpi-total"
      sub={`${totals.by_type.call} llamadas · ${totals.by_type.whatsapp} WA · ${totals.by_type.sms} SMS · ${totals.by_type.email} email`} />
    <Kpi icon={Target} label="Tasa de contacto" value={pct(totals.contact_rate)} tone="text-teal-700" testId="gestion-kpi-contact-rate"
      sub={`${totals.positives} positivas de ${totals.attempts} intentos`} />
    <Kpi icon={Users} label="Titulares gestionados" value={totals.unique_debtors} testId="gestion-kpi-debtors"
      sub={`${pct(totals.coverage)} de ${totals.portfolio_debtors} en cartera`} />
    <Kpi icon={HandCoins} label="Promesas cumplidas" value={pct(promises.compliance_rate)} tone="text-violet-700" testId="gestion-kpi-promises"
      sub={`${promises.kept} cumplidas · ${promises.broken} incumplidas · ${promises.pending} pendientes`} />
    <Kpi icon={Send} label="Mensajes enviados" value={totals.messages_sent} testId="gestion-kpi-sent"
      sub={`Prometido ${fmtMoney(promises.amount_promised)} · cobrado ${fmtMoney(promises.amount_kept)}`} />
  </div>
);

export default GestionKpis;
